import { XChip } from '@adornis/chemistry/elements/components/x-chip.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-chip
 */
@customElement('cr-chip')
export class ChromiumChip extends XChip {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host([small]) cr-text': {
          fontSize: '8px',
          lineHeight: '10px',
        },
      },
    ];
  }
}
